import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { selectFolder } from '../../actions/folders/actions';
import { unselectAll } from '../../actions/selected';
import { FoldersListItem } from '../../components/FoldersList/FoldersListItem';
import { addQueryToHistory } from '../../hooks/browserHistory';
import { selectAllCount, selectSelectedId } from '../../selectors/folders';
import { getTextCount } from '../../utils/favoriteEntity';

const folderIcon = require('./img/folder.png');

export function FoldersListItemAllContainer() {
  const dispatch = useDispatch();
  const selectedFolderId = useSelector(selectSelectedId);
  const totalCount = useSelector(selectAllCount);

  const handleClick = () => {
    addQueryToHistory({});
    dispatch(selectFolder({ folder: null }));
    dispatch(unselectAll());
    dispatch(fetchFavoriteEntities({ offset: 0 }));
  };

  return (
    <FoldersListItem
      image={<img src={folderIcon} alt="Папка" width={24} height={24} />}
      selected={!selectedFolderId}
      title="Все объявления"
      description={getTextCount(totalCount)}
      onClick={handleClick}
    />
  );
}
